import { BufferGeometry } from 'three';
const precision = Math.pow(10, 4);
export class GeometryBuilder {
    constructor(attributes) {
        this.attributes = attributes;
        this.indices = [];
        this.vertices = Object.keys(attributes).map(() => []);
        this.vertexCount = 0;
        this.keyedVertices = new Map();
    }
    addTriangle(vertices) {
        this.indices.push(...this.addVertices(vertices));
    }
    addQuad(vertices) {
        const vertexIds = this.addVertices(vertices);
        this.indices.push(...[0, 1, 2, 0, 2, 3].map(i => vertexIds[i]));
    }
    bake() {
        const geometry = new BufferGeometry();
        geometry.setIndex(this.indices);
        for (let i = 0; i < this.attributes.length; i++) {
            const [name, size, klass] = this.attributes[i];
            geometry.setAttribute(name, new klass(this.vertices[i], size));
        }
        return geometry;
    }
    addVertices(vertices) {
        return vertices.map(v => this.addVertex(v));
    }
    addVertex(vertex) {
        const key = vertex.map(v => v.map(f => Math.round(f * precision)).join(',')).join('-');
        if (this.keyedVertices.has(key)) {
            return this.keyedVertices.get(key);
        }
        const vertexId = this.vertexCount++;
        for (let i = 0; i < this.vertices.length; i++) {
            this.vertices[i].push(...vertex[i]);
        }
        this.keyedVertices.set(key, vertexId);
        return vertexId;
    }
}
